export const getCsrfToken = () => {
  const csrfCookie = document.cookie
    .split(';')
    .map((cookie) => cookie.split('=').map((part) => part.trim()))
    .filter((keys) => keys[0]!.toLowerCase() === 'x-csrf-token')[0]!;

  return (csrfCookie && csrfCookie[1]) || null;
};
